import axios from 'axios'

const services = {
  getTrackingInfo: ({ trackingId }) => axios.get(`${import.meta.env.VITE_HOST}/labels/${trackingId}`),
  getOrderTrackingInfo: ({ orderId }) => axios.get(`${import.meta.env.VITE_HOST}/orders/${orderId}`),
  sendRating: ({ trackingId, rating }) =>
    axios.post(`${import.meta.env.VITE_HOST}/labels/${trackingId}/rate`, { rating }),
  getRecommendedProducts: ({ orderId, params }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/orders/${orderId}/recommended-products`, { params })
  },
}

export default services
